import { CommissionStatuses } from 'constants/commissionStatuses';
import { EMPTY_FIELD } from 'constants/emptyField';
import { Resources } from 'constants/resources';

import { Box } from 'shared/mui/Box';
import { LinkButton } from 'shared/mui/Buttons';
import { TooltipWithInfoIcon } from 'shared/mui/Tooltip';
import { Typography } from 'shared/mui/Typography';
import { FunctionField, FunctionFieldProps } from 'shared/react-admin/Fields';
import { Commission, CommissionRate } from 'types/embedded/commission';

type Props = Omit<FunctionFieldProps, 'render'>;

export const CommissionsListDatagridRateField: React.FC<Props> = (props) => {
  const getCommissionRateString = (rate: CommissionRate) => {
    return `${rate?.percent ? rate?.percent + '%' : EMPTY_FIELD} / ${rate?.fix || EMPTY_FIELD} /
    ${rate?.max || EMPTY_FIELD} / ${rate?.min || EMPTY_FIELD}`;
  };

  return (
    <FunctionField
      render={(record: Commission) => {
        if (record?.ladder && record.status?.value === CommissionStatuses.Implemented) {
          return (
            <LinkButton
              label="Перейти"
              pathParams={{
                resource: Resources.Commissions,
                id: record.id,
                type: 'show',
                pathSuffix: '/5',
              }}
            />
          );
        }
        if (record?.ladder) {
          const firstStepRates = record?.ladder?.steps?.[0]?.commissionRate;
          return (
            <Box alignItems="center" display="flex" gap="4px">
              <Typography fontSize={14}>{getCommissionRateString(firstStepRates)}</Typography>
              <TooltipWithInfoIcon tooltipText="Значения первой ступени лесенки" />
            </Box>
          );
        }
        return getCommissionRateString(record.rate);
      }}
      {...props}
    />
  );
};
